import { tv } from 'tailwind-variants';

export const splitBanner = tv({
  slots: {
    section: 'w-full overflow-hidden lg:h-[32.5rem] 2xl:h-[40rem]',
    container: 'flex h-full items-center ',
    sideImage: 'relative h-80 w-full lg:h-[32.5rem] lg:w-1/2 2xl:h-[40rem]',
    textContainer: 'w-full px-6 py-12 lg:w-1/2 lg:px-12 lg:py-0 2xl:px-20'
  },
  variants: {
    type: {
      reverse: {
        container: 'flex-col-reverse justify-between lg:flex-row-reverse'
      },
      normal: {
        container: 'flex-col lg:flex-row'
      }
    }
  }
});
